import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
const TWO_HOURS_MS = 2 * 60 * 60 * 1000;
function getStoredEndTime(): number {
  const stored = localStorage.getItem('imperio_countdown_end');
  if (stored) {
    const end = parseInt(stored, 10);
    if (end > Date.now()) return end;
  }
  const end = Date.now() + TWO_HOURS_MS;
  localStorage.setItem('imperio_countdown_end', end.toString());
  return end;
}
function formatUnit(n: number): string {
  return n.toString().padStart(2, '0');
}
export function CountdownBanner() {
  const [endTime] = useState(getStoredEndTime);
  const [timeLeft, setTimeLeft] = useState(() => Math.max(0, endTime - Date.now()));
  useEffect(() => {
    const interval = setInterval(() => {
      const remaining = Math.max(0, endTime - Date.now());
      setTimeLeft(remaining);
      if (remaining <= 0) clearInterval(interval);
    }, 1000);
    return () => clearInterval(interval);
  }, [endTime]);
  const totalSeconds = Math.floor(timeLeft / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  if (timeLeft <= 0) return null;
  return <div className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-gold via-gold to-gold-dark text-navy" data-id="element-1">
      <div className="max-w-6xl mx-auto px-3 sm:px-4 py-2 sm:py-2.5 flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-3 font-heading font-bold" data-id="element-2">
        <div className="flex items-center gap-1.5 text-xs sm:text-sm" data-id="element-3">
          <span data-id="element-4">🔥 OFERTA DE LANZAMIENTO</span>
          <span className="font-normal text-navy/70" data-id="element-5">—</span>
          <span className="text-navy/80 font-semibold" data-id="element-6">
            La oferta termina en:
          </span>
        </div>
        <div className="flex items-center gap-1" data-id="element-7">
          <Clock className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-navy/70" data-id="element-8" />
          <div className="flex items-center gap-0.5 font-mono" data-id="element-9">
            <span className="bg-navy text-gold px-1.5 py-0.5 rounded text-xs sm:text-sm font-bold min-w-[24px] sm:min-w-[28px] text-center" data-id="element-10">
              {formatUnit(hours)}
            </span>
            <span className="text-navy/60 font-bold text-xs sm:text-sm" data-id="element-11">:</span>
            <span className="bg-navy text-gold px-1.5 py-0.5 rounded text-xs sm:text-sm font-bold min-w-[24px] sm:min-w-[28px] text-center" data-id="element-12">
              {formatUnit(minutes)}
            </span>
            <span className="text-navy/60 font-bold text-xs sm:text-sm" data-id="element-13">:</span>
            <span className="bg-navy text-gold px-1.5 py-0.5 rounded text-xs sm:text-sm font-bold min-w-[24px] sm:min-w-[28px] text-center" data-id="element-14">
              {formatUnit(seconds)}
            </span>
          </div>
        </div>
      </div>
    </div>;
}